import React from 'react';

const Copyright = () => {
  return (
    <div className='copyright-wrapper'>
      <div className='copyright-info'>2021 © Laundry</div>
    </div>
  );
};

export default Copyright;
